export default __webpack_public_path__ + "static/media/startup.d01c63da.svg";